const hearts = {
  0: "❤️",
  1: "🧡",
  2: "💛",
  3: "💚",
  4: "💙",
  5: "💜",
  6: "🤎",
  7: "🖤",
  8: "💖",
  9: "🤍",
};

const faces = {
  0: "😀",
  1: "🥳",
  2: "😂",
  3: "😍",
  4: "😜",
  5: "🤩",
  6: "🙃",
  7: "🤔",
  8: "😆",
  9: "😮",
};

const animals = {
  0: "🐶",
  1: "🦊",
  2: "🦄",
  3: "🐯",
  4: "🐷",
  5: "🐮",
  6: "🐱",
  7: "🦁",
  8: "🐰",
  9: "🐼",
};

const numbers = {
  0: "0️⃣",
  1: "1️⃣",
  2: "2️⃣",
  3: "3️⃣",
  4: "4️⃣",
  5: "5️⃣",
  6: "6️⃣",
  7: "7️⃣",
  8: "8️⃣",
  9: "9️⃣",
};

const Themes = {
  hearts,
  faces,
  animals,
  numbers,
};

export default Themes;
